module.exports = __webpack_public_path__ + "img/ic_chair_handh.786cd883.png";